const container = {
  FULL: 'Fullwidth',
  LEFT_SIDEBAR: '1/3 left - 2/3 right',
  RIGHT_SIDEBAR: '2/3 left - 1/3 right',
  HALF_SIDEBAR: '1/2 left - 1/2 right',
  ONE_THIRD: '1/3 left - 1/3 center - 1/3 right',
};

export default Object.freeze(container);
